window.zESettings = {
webWidget: {
    offset: {
    horizontal: '0px',
    vertical: '0px'
    },
    position: {
    horizontal: 'right',
    vertical: 'bottom'
    },
    launcher: {
    mobile: {
        labelVisible: true
    }
    }
}
};


function adjustWidgetVisibility() {
const isProductPage = window.location.pathname.includes('/products/');
const isMobile = window.innerWidth < 800;
const isWidgetHidden = isMobile && isProductPage;

if (isWidgetHidden) {
    zEmbed('webWidget', 'hide');
} else {
    zEmbed('webWidget', 'show');
}
}


adjustWidgetVisibility();

window.addEventListener('resize', adjustWidgetVisibility);

function openContactForm(event) {
if (event) {
    event.preventDefault();
    event.stopPropagation();
}
zEmbed('webWidget', 'show');
zEmbed('webWidget', 'open');
}

zEmbed('webWidget:on', 'close', function() {
adjustWidgetVisibility();
});

const urlParams = new URLSearchParams(window.location.search);
if (urlParams.has('contact') && urlParams.get('contact').toLowerCase() === 'true') {
openContactForm();
}